import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  summarizeConsultationReportQuery as SummarizeConsultationReportQuery,
} from "@/modules/patients/detail/consultation-report/services/__generated__/summarizeConsultationReportQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query summarizeConsultationReportQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    summarizeConsultationReport: ch_summarizeConsultationReport(aiRequestMetadata: $aiRequestMetadata) {
      anamnesisSummary
      recommendedTreatment
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const summarizeConsultationReportQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<SummarizeConsultationReportQuery>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
